module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seatbelts-flyo-47e43b17aa716000c80041d56e1eb36b.svg";